// extracted by mini-css-extract-plugin
module.exports = {"input-label":"styles_input-label__3QHms","inputLabel":"styles_input-label__3QHms"};